import {
  Ng1StateDeclaration,
  Ng1ViewDeclaration,
  StateParams,
  StateRegistry,
  StateService,
} from "@uirouter/angularjs";
import { IServiceProvider } from "angular";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../records/server/serverUtility";
import {
  GridConfiguration,
  vsComponentName as RecordGridViewComponentName,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../records/views/recordGridView";
//import { vsComponentName as machineDetailContactBookComponentName } from "../views/info";
import {
  vsComponentName as FormViewComponentName,
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../records/forms/formView";
import { Record } from "../../records/server/crud";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../application/UserProfile";
export const vsServiceName = "contactBookService";
export const vsProviderName = `${vsServiceName}Provider`;

const baseState = "main.contactBook.type";

const createState = `${baseState}.create`;
const gridState = `${baseState}.grid`;

const infoState = `${baseState}.info`;
const editState = `${infoState}.edit`;
const infoRedirectState = `${infoState}.redirect`;

export class ContactBookServiceProvider implements IServiceProvider {
  static $inject = [];
  constructor() {}

  private readonly _contactBookTypes: IContactBookType[] = [];
  private readonly _contactBookTabs: IContactBookTab[] = [];

  addContactBookType(contactBookType: IContactBookType) {
    this._contactBookTypes.push(contactBookType);
  }

  addContactBookTab(contactBookTab: IContactBookTab) {
    this._contactBookTabs.push(contactBookTab);
  }

  $get = [
    "$state",
    "$stateRegistry",
    FormViewServiceName,
    serverUtilityName,
    UserProfileName,
    (
      $state: StateService,
      $stateRegistry: StateRegistry,
      formViewService: FormViewService,
      serverUtility: ServerUtility,
      userProfile: UserProfile
    ) => {
      $stateRegistry.register({
        name: baseState,
        url: "/:type",
        abstract: true,
        params: {
          type: undefined,
        },
        resolve: {
          contactBookType: [
            vsServiceName,
            "$stateParams",
            (contactBookService: ContactBookService, $stateParams: StateParams) =>
              contactBookService.getContactBookType($stateParams.type),
          ],
        },
      });

      $stateRegistry.register({
        name: createState,
        url: "/create",
        component: FormViewComponentName,
        resolve: FormViewService.getResolveObjectFromFormViewConfig(
          [
            "contactBookType",
            (contactBookType: ContactBookTypeService) =>
              formViewService.getFormViewConfig(contactBookType.formConfigName)!,
          ],
          [
            () => {
              return {};
            },
          ]
        ),
      });

      $stateRegistry.register({
        name: editState,
        url: "/edit",
        views: {
          "": {
            component: FormViewComponentName,
          },
        },
        resolve: {
          ...FormViewService.getResolveObjectFromFormViewConfig(
            [
              "contactBookType",
              (contactBookType: ContactBookTypeService) =>
                formViewService.getFormViewConfig(contactBookType.formConfigName)!,
            ],
            ["contactBook", (contactBook: any) => contactBook],
            [
              "$state",
              ($state: StateService) => [() => $state.go("^.redirect")],
            ]
          ),
        },
      });

      $stateRegistry.register({
        name: gridState,
        url: "/grid",
        component: RecordGridViewComponentName,
        resolve: {
          ...RecordGridViewService.getResolveObjectFromGridConfiguration([
            "contactBookType",
            RecordGridViewServiceName,
            (
              contactBookType: ContactBookTypeService,
              recordGridViewService: RecordGridViewService
            ) => {
              const gridConfiguration =
                recordGridViewService.getGridConfiguration(
                  contactBookType.gridConfigName
                );
              if (!gridConfiguration) {
                throw new Error("Couldn't resolve grid configuration.");
              }
              gridConfiguration.onAddNew = () =>
                contactBookType.createNavigate().then(() => {});
              return gridConfiguration;
            },
          ]),
          columns: [
            "contactBookType",
            "gridConfiguration",
            ColumnDefinitionServiceName,
            (
              contactBookType: ContactBookTypeService,
              gridConfiguration: GridConfiguration,
              columnDefinitionService: ColumnDefinitionService
            ) => [
              columnDefinitionService.getLinkColDef({
                colId: "info",
                headerName: "Info",
                iconClass: "fa fa-info-circle text-primary",
                stateExpression: `${contactBookType.infoSref()}({contactBookInstanceId: data.ContactBookInstanceId})`,
              }),
              columnDefinitionService.getLinkColDef({
                colId: "edit",
                headerName: "Edit",
                iconClass: "fa fa-pencil text-primary",
                stateExpression: `${contactBookType.editSref()}({contactBookInstanceId: data.ContactBookInstanceId, type: data.ContactBookInstanceType})`,
                requiresPermission: "contactBookEdit",
              }),
              ...(gridConfiguration.columns ?? []),
            ],
          ],
        },
      });

      // $stateRegistry.register({
      //   name: infoState,
      //   url: "/{contactBookInstanceId:int}",
      //   component: machineDetailContactBookComponentName,
      //   resolve: {
      //     contactBook: [
      //       "$stateParams",
      //       "contactBookType",
      //       ($stateParams: StateParams, contactBookType: ContactBookTypeService) =>
      //         contactBookType.fetchContactBook($stateParams.contactBookInstanceId),
      //     ],
      //   },
      // });

      $stateRegistry.register({
        name: infoRedirectState,
        onEnter: [
          "$state",
          "contactBookType",
          "$stateParams",
          (
            $state: StateService,
            contactBookType: ContactBookTypeService,
            $stateParams: StateParams
          ) =>
            $state.target(contactBookType.infoSref(), {
              type: $stateParams.type,
              contactBookInstanceId: $stateParams.contactBookInstanceId,
            }),
        ],
      });

      const defaultViews = {};

      this.registerContactBookTabs(
        $stateRegistry,
        infoState,
        this._contactBookTabs,
        //add default detail view
        defaultViews
      );

      const contactBookTypes: ContactBookTypeService[] = [];
      const contactBookService = new ContactBookService(
        $state,
        contactBookTypes,
        this._contactBookTabs,
        formViewService,
        serverUtility,
        userProfile
      );
      contactBookTypes.push(
        ...this._contactBookTypes.map((ct) => {
          const typeSpecificTabs = (ct.tabs ??= []);
          this.registerContactBookTabs(
            $stateRegistry,
            infoState,
            typeSpecificTabs,
            defaultViews
          );
          ct.tabs = [...typeSpecificTabs, ...this._contactBookTabs];
          return new ContactBookTypeService(contactBookService, ct);
        })
      );

      return contactBookService;

      
    },
  ];

  registerContactBookTabs(
    $stateRegistry: StateRegistry,
    basePath: string,
    tabs: IContactBookTab[],
    views?: { [key: string]: Ng1ViewDeclaration }
  ) {
    tabs.forEach((t) => {
      const stateName = (t.state.name ??= `${basePath}.${t.uiSref}`);
      t.state.views = { ...views, ...t.state.views };

      $stateRegistry.register(t.state);
      this.registerContactBookTabs($stateRegistry, stateName, t.children ?? []);
    });
  }
}

export class ContactBookService {
  constructor(
    private readonly $state: StateService,
    private readonly contactBookTypes: ContactBookTypeService[],
    private readonly contactBookTabs: IContactBookTab[],
    private readonly formViewService: FormViewService,
    private readonly serverUtility: ServerUtility,
    private readonly userProfile: UserProfile
  ) {}

  getContactBookType(id: string): ContactBookTypeService | undefined {
    return this.contactBookTypes.find((ct) => ct.id === id);
  }

  getContactBookTabs(): IContactBookTab[] {
    return this.contactBookTabs;
  }

  getContactBookTypes(): ContactBookTypeService[] {
    return this.contactBookTypes;
  }

  gridNavigate(type: string) {
    return this.$state.go(gridState, { type });
  }

  gridSref(type: string) {
    return gridState;
  }

  infoNavigate(type: string, contactBookInstanceId: number) {
    return this.$state.go(
      this.infoSref(type),
      { type, contactBookInstanceId },
      { reload: true }
    );
  }

  infoSref(type: string, tab?: IContactBookTab, routeParams?: any) {
    const contactBookType = this.getContactBookType(type);
    tab ??= contactBookType?.tabs?.at(0);

    const paramString = routeParams ? `(${JSON.stringify(routeParams)})` : "";

    if (tab) {
      return `${infoState}.${tab.uiSref}${paramString}`;
    }

    return infoState;
  }

  editNavigate(type: string, contactBookInstanceId: number) {
    return this.$state.go(this.editSref(type), { type, contactBookInstanceId });
  }

  editSref(type: string) {
    return editState;
  }

  createNavigate(type: string) {
    return this.$state.go(this.createSref(type), { type });
  }

  createSref(type: string) {
    return createState;
  }

  hasSensitiveInfoPermission(type: string) {
    const contactBookType = this.getContactBookType(type);
    const permission = contactBookType?.sensitiveInfoPermission;
    return permission ? this.userProfile.hasPermission(permission) : false;
  }

  fetchContactBook<TContactBook extends Record>(
    type: string,
    contactBookInstanceId: number
  ) {
    const addressBookType = this.getContactBookType(type)!;

    return this.serverUtility.getById<TContactBook>({
      url: `/api/addressBook/${addressBookType.id}/byInstance`,
      id: contactBookInstanceId,
    });
  }

  submitContactBook<TContactBook extends Record & IHasContactBookInstanceId>(
    type: string,
    contactBook: TContactBook,
    formViewController: FormViewController
  ) {
    if (!contactBook) {
      throw new Error("ContactBook object is undefined.");
    }

    const addressBookType = this.getContactBookType(type)!;

    const newRecord = !contactBook.Id;
    const apiEndpoint =
      `/api/addressBook/${addressBookType.id}` + (newRecord ? "" : `/${contactBook.Id}`);

    return this.formViewService.submitForm<TContactBook>({
      formObject: contactBook,
      formViewController,
      method: newRecord ? "POST" : "PUT",
      url: apiEndpoint,
    });
  }

  private getFirstInfoState(contactBookType: IContactBookType) {
    return contactBookType.tabs?.at(0)?.uiSref ?? infoState;
  }
}

//do this so contactBook service is instantiated and routes get registered as early as possible
ContactBookServiceRun.$inject = [vsServiceName];
export function ContactBookServiceRun() {}

export class ContactBookTypeService implements IContactBookType {
  constructor(
    private readonly contactBookService: ContactBookService,
    contactBookType: IContactBookType
  ) {
    Object.assign(this, contactBookType);

    this.formConfigName ??= contactBookType.name;
    this.gridConfigName ??= contactBookType.name;
    this.tabs ??= [];
  }

  fetchContactBook(contactBookInstanceId: number) {
    return this.contactBookService.fetchContactBook(this.id, contactBookInstanceId);
  }

  submitContactBook(
    contactBook: Record & IHasContactBookInstanceId,
    formViewController: FormViewController
  ) {
    return this.contactBookService.submitContactBook(
      this.id,
      contactBook,
      formViewController
    );
  }

  infoSref(tab?: IContactBookTab, routeParams?: any) {
    return this.contactBookService.infoSref(this.id, tab, routeParams);
  }

  infoNavigate(contactBookInstanceId: number) {
    return this.contactBookService.infoNavigate(this.id, contactBookInstanceId);
  }

  gridSref() {
    this.contactBookService.gridSref(this.id);
  }

  gridNavigate() {
    return this.contactBookService.gridNavigate(this.id);
  }

  editNavigate(contactBookInstanceId: number) {
    return this.contactBookService.editNavigate(this.id, contactBookInstanceId);
  }

  editSref() {
    return this.contactBookService.editSref(this.id);
  }

  createNavigate() {
    return this.contactBookService.createNavigate(this.id);
  }

  createSref() {
    return this.contactBookService.createSref(this.id);
  }

  hasSensitiveInfoPermission(): boolean {
    return this.contactBookService.hasSensitiveInfoPermission(this.id);
  }
  sensitiveInfoPermission?: string;

  id!: string;
  name!: string;
  formConfigName: string;
  gridConfigName: string;
  detailComponentName!: string;
  tabs?: IContactBookTab[];
}

export interface IContactBookType {
  id: string;
  name: string;
  //formComponentName: string;
  detailComponentName: string;
  formConfigName: string;
  gridConfigName: string;
  tabs?: IContactBookTab[];
  sensitiveInfoPermission?: string | string[];
}

export interface IHasContactBookInstanceId {
  ContactBookInstanceId: number;
}

export interface IContactBookTab {
  uiSref: string;
  name: string;
  state: Ng1StateDeclaration;
  children?: IContactBookTab[];
}
